"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsRegister = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var userLogin_1 = require("../../model/userLogin");
var service_1 = require("../../../library/base/service");
var IsRegister = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(IsRegister, _super);
    function IsRegister() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '判断用户是否注册接口';
        _this.code = '101111';
        _this.desc = '';
        _this.requestParams = new userLogin_1.IsRegisterRequest();
        _this.method = fetch_1.Methods.POST;
        _this.isSecurity = false;
        return _this;
    }
    return IsRegister;
}(service_1.BaseService));
exports.IsRegister = IsRegister;
//# sourceMappingURL=isRegister.js.map